import ProfileDetails from '@/core/components/ProfileDetails/ProfileDetails';

export default ProfileDetails;
